import React, { useState } from 'react';
import { motion } from 'framer-motion';
import copy from 'copy-to-clipboard';
import Layout from '../components/Layout';
import Textarea from '../components/Textarea';
import Button from '../components/Button';
import { convertCase } from '../utils/textUtils';

const CaseConverter: React.FC = () => {
  const [text, setText] = useState('');
  const [result, setResult] = useState('');
  const [showToast, setShowToast] = useState(false);

  const handleConvert = (type: keyof typeof convertCase) => {
    const converted = convertCase[type](text);
    setResult(converted);
  };

  const handleCopy = () => {
    copy(result);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000);
  };

  return (
    <Layout showBackButton>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-32"
        >
          <h1 className="text-4xl font-bold text-textPrimary mb-8">
            대소문자 변환
          </h1>
          <p className="text-textSecondary">
            영문 텍스트를 다양한 형태로 변환
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="mb-24"
        >
          <Textarea
            value={text}
            onChange={setText}
            placeholder="영문 텍스트를 입력하세요..."
          />
        </motion.div>

        {text && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-24"
          >
            <div className="flex flex-wrap gap-12 mb-24">
              <Button onClick={() => handleConvert('toUpperCase')}>
                모두 대문자
              </Button>
              <Button onClick={() => handleConvert('toLowerCase')}>
                모두 소문자
              </Button>
              <Button onClick={() => handleConvert('toTitleCase')}>
                첫글자 대문자
              </Button>
              <Button onClick={() => handleConvert('toSentenceCase')}>
                문장 형식
              </Button>
              <Button onClick={() => handleConvert('toggleCase')}>
                토글 케이스
              </Button>
            </div>

            {result && (
              <div>
                <label className="block text-textSecondary mb-8 text-sm">
                  변환 결과
                </label>
                <Textarea value={result} onChange={setResult} />
                <div className="mt-12">
                  <Button onClick={handleCopy}>결과 복사</Button>
                </div>
              </div>
            )}
          </motion.div>
        )}

        {showToast && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className="fixed bottom-32 left-1/2 transform -translate-x-1/2 bg-textPrimary text-white px-24 py-12 rounded-medium shadow-lg"
          >
            ✓ 복사됨
          </motion.div>
        )}
      </div>
    </Layout>
  );
};

export default CaseConverter;
